import { render, staticRenderFns } from "./AvalonEditor.vue?vue&type=template&id=899b2d82&scoped=true&"
import script from "./AvalonEditor.vue?vue&type=script&lang=js&"
export * from "./AvalonEditor.vue?vue&type=script&lang=js&"
import style0 from "./AvalonEditor.vue?vue&type=style&index=0&id=899b2d82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "899b2d82",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCol,VFadeTransition,VIcon,VProgressCircular,VRow,VSheet})
